import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { ScrollToTop } from './components/ScrollToTop';
import { AlertBar } from './components/AlertBar';
import { Footer } from './components/Footer';
import { AuthProvider } from './contexts/AuthContext';
import { RequestsProvider } from './contexts/RequestsContext';
import { PermitsProvider } from './contexts/PermitsContext';
import { RequireAuth } from './components/auth/RequireAuth';
import { EspaceProvider } from './contexts/EspaceContext';
import { EspaceLayout } from './components/espace/EspaceLayout';
import { Accueil } from './pages/Accueil';
import { MaCarte } from './pages/MaCarte';
import { MesCollectes } from './pages/MesCollectes';
import { MonCompteurEau } from './pages/MonCompteurEau';
import { CalendrierCollectes } from './pages/CalendrierCollectes';
import { MonProfil } from './pages/MonProfil';
import { MesLoisirs } from './pages/MesLoisirs';
import { AvisNotifications } from './pages/AvisNotifications';
import { ParametresAvis } from './pages/ParametresAvis';
import { MesDemandes } from './pages/MesDemandes';
import { DemandeDetail } from './pages/DemandeDetail';
import { MesPermis } from './pages/MesPermis';
import { PermisDetail } from './pages/PermisDetail';
import { PermisFormulaire } from './pages/PermisFormulaire';
import { MonEspace } from './pages/MonEspace';
import { MesAnimaux } from './pages/MesAnimaux';
import { Plan } from './pages/Plan';
import { AnimalDetail } from './pages/AnimalDetail';
interface AppProps {
  showAlertBar?: boolean;
  showEvents?: boolean;
}
export function App({
  showAlertBar = true,
  showEvents = true
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3dle1ulujigpf">
        <AuthProvider data-id="element-1" data-mp="3dlw5i3jj7x7d">
          <RequestsProvider data-id="element-2" data-mp="3dmfmni1cyhkc">
          <PermitsProvider data-id="element-3" data-mp="3dii6n5a2u64o">
          <EspaceProvider data-id="element-4" data-mp="nw2bq4xkjoqk">
          <div id="accueil" className="min-h-screen w-full bg-white" data-id="element-5" data-mp="nur6e0oh68xc">
            <ScrollToTop data-id="element-6" data-mp="su43rfcz2ye6" />
            <div className="sticky top-0 z-40" data-id="element-7" data-mp="stc8k5naf2of">
              <Header data-id="element-8" data-mp="36hx792iaw2a" />
              {showAlertBar && <AlertBar data-id="element-9" data-mp="35gm54lhq9kk" />}
            </div>
            <EspaceLayout data-id="element-10" data-mp="38b5essrpoce">
              <Routes data-id="element-11" data-mp="3ud1dv4v0xg8i">
                <Route path="/" element={<Accueil showEvents={showEvents} data-id="element-13" data-mp="3uc9o4ao3ycq5" />} data-id="element-12" data-mp="3ubrgyizwqe3g" />
                <Route path="/plan" element={<Plan data-id="element-15" data-mp="d3cvprys4wgk" />} data-id="element-14" data-mp="d57ep0qhqei0" />
                <Route path="/ma-carte" element={<RequireAuth label="Ma carte numérique" data-id="element-17" data-mp="86cmj86mvdl8">
                      <MaCarte data-id="element-18" data-mp="3gklc07duzo96" />
                    </RequireAuth>} data-id="element-16" data-mp="d2l8p5j9071w" />
                <Route path="/mes-collectes" element={<RequireAuth label="Mes collectes" data-id="element-20" data-mp="3qbfwb67jodrz">
                      <MesCollectes data-id="element-21" data-mp="3qd0s0z5li2rf" />
                    </RequireAuth>} data-id="element-19" data-mp="3bn314bga6yyj" />
                <Route path="/mes-collectes/calendrier" element={<RequireAuth label="Le calendrier des collectes" data-id="element-23" data-mp="2svtm5mnqrhzk">
                      <CalendrierCollectes data-id="element-24" data-mp="2svjyi5q65mx1" />
                    </RequireAuth>} data-id="element-22" data-mp="3limv2sbabnkn" />
                <Route path="/mon-compteur-eau" element={<RequireAuth label="Mon compteur d’eau" data-id="element-26" data-mp="1d6kkm9tu85l5">
                      <MonCompteurEau data-id="element-27" data-mp="ygwl9e57vh02" />
                    </RequireAuth>} data-id="element-25" data-mp="18byae9zhsj2n" />
                <Route path="/mon-profil" element={<RequireAuth label="Mon profil" data-id="element-29" data-mp="1r5kd5skh14ml">
                      <MonProfil data-id="element-30" data-mp="1w3c0e9a682kg" />
                    </RequireAuth>} data-id="element-28" data-mp="13f7vhpzfbtit" />
                <Route path="/mes-loisirs" element={<RequireAuth label="Mes loisirs" data-id="element-32" data-mp="1m560tybu78ir">
                      <MesLoisirs data-id="element-33" data-mp="1m3l7gc19dvmh" />
                    </RequireAuth>} data-id="element-31" data-mp="1i3ulclmog3oa" />
                <Route path="/notifications" element={<RequireAuth label="Mes avis et notifications" data-id="element-35" data-mp="arkf6n56rp1z">
                      <AvisNotifications data-id="element-36" data-mp="qxf7vqfa53ia" />
                    </RequireAuth>} data-id="element-34" data-mp="6mukh1m9kgin" />
                <Route path="/notifications/parametres" element={<RequireAuth label="Mes préférences de communication" data-id="element-38" data-mp="h8dqbvt36e27">
                      <ParametresAvis data-id="element-39" data-mp="c8rf1rwtj7w1" />
                    </RequireAuth>} data-id="element-37" data-mp="m5dz4ehblux0" />
                <Route path="/mes-demandes" element={<RequireAuth label="Mes demandes" data-id="element-41" data-mp="14wetep7hx2a8">
                      <MesDemandes data-id="element-42" data-mp="14uu0f40txreh" />
                    </RequireAuth>} data-id="element-40" data-mp="19w9oz627ug1m" />
                <Route path="/mes-demandes/:id" element={<RequireAuth label="Mes demandes" data-id="element-44" data-mp="vybe4an3t1qv">
                      <DemandeDetail data-id="element-45" data-mp="3kp41ep3izhar" />
                    </RequireAuth>} data-id="element-43" data-mp="zzoi0f6myuv5" />
                <Route path="/mes-permis" element={<RequireAuth label="Mes permis" data-id="element-47" data-mp="1w5gdkpqobu3q">
                      <MesPermis data-id="element-48" data-mp="2060abs7c4vpc" />
                    </RequireAuth>} data-id="element-46" data-mp="3gloam9e50b5z" />
                <Route path="/mes-permis/formulaire" element={<RequireAuth label="Mes permis" data-id="element-50" data-mp="29vtp122rxqxt">
                      <PermisFormulaire data-id="element-51" data-mp="29xeh8l1m8xsi" />
                    </RequireAuth>} data-id="element-49" data-mp="2553j9nqfrm2l" />
                <Route path="/mes-permis/:id" element={<RequireAuth label="Mes permis" data-id="element-53" data-mp="2js6e1mndjgm8">
                      <PermisDetail data-id="element-54" data-mp="2nv341yf8uf07" />
                    </RequireAuth>} data-id="element-52" data-mp="2eun2iui29hxz" />
                <Route path="/mon-espace" element={<RequireAuth label="Mon espace citoyen" data-id="element-56" data-mp="ti3epdl2a6fq">
                      <MonEspace data-id="element-57" data-mp="tjodxgibmdjx" />
                    </RequireAuth>} data-id="element-55" data-mp="2suxs7u7mwqhk" />
                <Route path="/mes-animaux" element={<RequireAuth label="Mes animaux" data-id="element-59" data-mp="21tojc52kt18v">
                      <MesAnimaux data-id="element-60" data-mp="1wtixx6mwgaz8" />
                    </RequireAuth>} data-id="element-58" data-mp="yihqn6psa0j1" />
                <Route path="/mes-animaux/:id" element={<RequireAuth label="Mes animaux" data-id="element-62" data-mp="25s4bsohff1to">
                      <AnimalDetail data-id="element-63" data-mp="25vicztect4zj" />
                    </RequireAuth>} data-id="element-61" data-mp="2atbislbqvwza" />
                <Route path="*" element={<Accueil showEvents={showEvents} data-id="element-65" data-mp="2fs4zsnq8q647" />} data-id="element-64" data-mp="2frd1v6967war" />
              </Routes>
            </EspaceLayout>
            <Footer data-id="element-66" data-mp="2tj01ng2bnmya" />
          </div>
          </EspaceProvider>
          </PermitsProvider>
          </RequestsProvider>
        </AuthProvider>
    </BrowserRouter>;
}